import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=c96ef8c6&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=js&"
export * from "./ReportHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=c96ef8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96ef8c6",
  null
  
)

export default component.exports